import IEventApi from '@/common/events/api/IEventApi';
import store from '@/store';
import { IDeviceChangedEvent } from '@/common/apis/DeviceApi';
import Logger from '@/common/logging/Logger';


export default function register(api: IEventApi) {
    const logger = Logger('device-event');
    api.onEvent<IDeviceChangedEvent>('DeviceChangedEvent', (t) => {
        logger.debug('event changed', t);
        store.commit('devices/deviceChanged', t.deviceInfo);
    });

}
// [Debug] event-api | new event FileTransferProgressEvent: {"outgoing":true,"bytesTransferred":162031,
// "bytesTotal":1198080,"deviceNumber":"D1022","timestamp":"2019-11-10T20:58:55.214768+01:00"} (app.7af6c465.js, line 1, x8)
